import { formatDate } from "../../i18n/dateLocale";
import React from "react";
import { useTranslation } from "react-i18next";


const ItvsTable = (props) => {
    const { t } = useTranslation();
    return (
        <div className="table-wrapper px-3 pt-3">
            <div className="d-flex flex-wrap">
                <p className="table-type">{t("admin.ivts.table.allKiosk")}</p>

            </div>
            <div className="table-wrapper-scroll-y table-scrollbar">
                <div className="table-own table-responsive">
                    <table className="table table-striped table-hover table-admin">
                        <thead className="table-head">
                            <tr>
                                <th
                                    className={`sort-header cursor ${props?.sortObj?.sortVal === "storeName" ? "active" : ""
                                        } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                    onClick={() => props.arraySorting("storeName")}
                                >
                                    <span>{t("admin.ivts.table.kioskName")}</span>{" "}
                                    {props?.sortObj?.sortType === "aesc" && (
                                        <i className="fas fa-caret-down"></i>
                                    )}
                                    {props?.sortObj?.sortType === "desc" && (
                                        <i className="fas fa-caret-up"></i>
                                    )}
                                </th>
                                <th
                                    className={`sort-header cursor ${props?.sortObj?.sortVal === "number" ? "active" : ""
                                        } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                    onClick={() => props.arraySorting("number")}
                                >
                                    <span>{t("admin.ivts.table.machineId")}</span>{" "}
                                    {props?.sortObj?.sortType === "aesc" && (
                                        <i className="fas fa-caret-down"></i>
                                    )}
                                    {props?.sortObj?.sortType === "desc" && (
                                        <i className="fas fa-caret-up"></i>
                                    )}
                                </th>
                                <th>
                                    <span>{t("admin.ivts.table.zone")}</span>
                                </th>
                                <th
                                    className={`sort-header cursor ${props?.sortObj?.sortVal === "address" ? "active" : ""
                                        } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                    onClick={() => props.arraySorting("address")}
                                >
                                    <span>{t("admin.ivts.table.address")}</span>{" "}
                                    {props?.sortObj?.sortType === "aesc" && (
                                        <i className="fas fa-caret-down"></i>
                                    )}
                                    {props?.sortObj?.sortType === "desc" && (
                                        <i className="fas fa-caret-up"></i>
                                    )}
                                </th>
                                <th
                                    className={`sort-header cursor ${props?.sortObj?.sortVal === "stockQuantity" ? "active" : ""
                                        } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                    onClick={() => props.arraySorting("stockQuantity")}
                                >
                                    <span>{t("admin.ivts.table.stockQuantity")}</span>{" "}
                                    {props?.sortObj?.sortType === "aesc" && (
                                        <i className="fas fa-caret-down"></i>
                                    )}
                                    {props?.sortObj?.sortType === "desc" && (
                                        <i className="fas fa-caret-up"></i>
                                    )}
                                </th>
                                <th>
                                    <span>{t("admin.ivts.table.lastActivity")}</span>
                                </th>
                                <th>
                                    <span>{t("admin.ivts.table.healthStatus")}</span>
                                </th>
                                <th>
                                    <span>{t("admin.ivts.table.lastOnline")}</span>
                                </th>
                                <th className="text-center">
                                    <span>{t("admin.ivts.table.hiddenOnMap")}</span>
                                </th>
                                <th className="text-center">
                                    <span>{t("common.status")}</span>
                                </th>
                                <th className="text-center">
                                    <span>{t("admin.ivts.table.qrCode")}</span>
                                </th>

                                <th>
                                    <span>{t("common.action")}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {props.dataList.map((data) => {
                                let address = data?.street;
                                if (data?.address) {
                                    address = address + ", " + data?.address;
                                }
                                address = address + ", " + data?.city;
                                return (
                                    <tr key={data?.ivtsId || "N/A"}>
                                        <td>{data?.name || "N/A"}</td>
                                        <td>{data?.number || "N/A"}</td>
                                        <td>{data?.zone || "N/A"}</td>
                                        <td>{address || "N/A"}</td>
                                        <td
                                            className={`${!data?.stockQuantity || Number(data?.stockQuantity) <= 0
                                                ? "color-red"
                                                : ""
                                                }`}
                                        >
                                            {data?.stockQuantity}
                                        </td>
                                        <td>{data?.lastActivity}</td>
                                        <td
                                            className={data?.onlineStatus
                                                ? "table-isactive"
                                                : "table-isinactive"
                                            }
                                        >
                                            {data?.onlineStatus
                                                ? t("common.online")
                                                : t("common.offline")
                                            }
                                        </td>
                                        <td>{data?.lastOnline ? formatDate(new Date(data?.lastOnline)) : "N/A"}</td>

                                        <td className="text-center">
                                            {data?.hideOnMap ? (
                                                <span className="table-isinactive">{t("common.yes")}</span>
                                            ) : (
                                                <span className="table-isactive">{t("common.no")}</span>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            {data?.isActivated ? (
                                                <span className="table-isactive">{t("common.active")}</span>
                                            ) : (
                                                <span className="table-isinactive">{t("common.inactive")}</span>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            <div
                                                className="cursor"
                                                onClick={() => props.viewQrData(data?.ivtsId)}
                                            >
                                                <i className="far fa-eye primary-color"></i>
                                            </div>
                                        </td>
                                        <td className="nowrap">
                                            <span
                                                className="mr-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                                                onClick={() => props?.manageStockData(data)}
                                            >
                                                {t("common.editStock")}
                                            </span>{" "}
                                            |{" "}
                                            <span
                                                className="mx-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                                                onClick={() => props.editData(data)}
                                            >
                                                {t("common.edit")}
                                            </span>{" "}
                                            |{" "}
                                            <span
                                                className="ml-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                                                onClick={() => props.deleteData(data)}
                                            >
                                                {t("common.delete")}
                                            </span>

                                            <span
                                                className="ml-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                                                onClick={() => props?.toggleData(data)}
                                            >

                                                {!data?.isActivated ? t("common.activate") : t("common.deactivate")}

                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ItvsTable;
